import styles from './ai-chat-window-loader.module.css';

/**
 * ### AiChatWindowLoader
 *
 * @description
 * Animated loader component displaying 4 dots that bounce vertically in sequence.
 * Each dot is 6px by 6px.
 *
 * @example
 * <AiChatWindowLoader />
 *
 * @returns React component
 */
const AiChatWindowLoader = () => {
  return (
    <div className={styles.loader} aria-label="Loading">
      <div className={styles.dot1} />
      <div className={styles.dot2} />
      <div className={styles.dot3} />
      <div className={styles.dot4} />
    </div>
  );
};

export default AiChatWindowLoader;
